import { createRoot } from "react-dom/client";
import App from "./App";
import "./compiled-tailwind.css";

createRoot(document.getElementById("root")!).render(<App />);
